<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <span>{{ $t('orders') }}</span>
      </template>
    </navbar>
    <!--END Navbar-->

    <b-card title="Search" class="my-0">
      <form v-on:submit.prevent>
        <b-input
            v-model="searchInput"
            placeholder="Bestellnummer,Vorname,Nachname ..."></b-input>
      </form>

    </b-card>
    <template v-if="report !== null">
      <report :report="report"></report>
    </template>
    <!--END Report-->

    <b-card class="mt-0 sticky-top" style="z-index: 99999" v-if="processGroup.form.orderIds.length > 0">
      <b-row>
        <b-col cols="12" md="3">
          <h3 class="font-weight-bold my-0">{{ $t('selectAction') }}</h3>
        </b-col>
        <b-col cols="12" md="9">
          <b-form-select
              @change="processGroupOrder"
              v-model="processGroup.form.type" :options="processGroup.items"></b-form-select>
        </b-col>

        <b-col cols="12" v-if="processGroup.form.type === 'changePaymentDate'">
          <b-form-group
              class="font-weight-bold"
              label="SELECT PAYMENT DATE">
            <date-picker
                format="YYYY-MM-DD"
                display-format="YYYY-MM-DD"
                @change="onSelectPaymentDate"
                locale="en" v-model="processGroup.form.orderPaymentDate"></date-picker>
          </b-form-group>
        </b-col>

      </b-row>
    </b-card>
    <!--END Select Action-->

    <h2 v-if="orders.length > 0" class="font-weight-bold">Orders count: {{ orders.length }}</h2>

    <b-row>
      <b-col cols="12" md="3">
        <div class="sticky-top2" style="top: 15px">
          <b-card>
            <div class="content-filter">
              <b-form-group
                  class="font-weight-bold"
                  label="PAYMENT TYPE">
                <b-form-checkbox-group
                    id="checkbox-group-1"
                    :options="filters.payment"
                    v-model="filters.form.paymentType"
                    @change="onSelectFilter"
                    name="paymentType"
                    stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group
                  class="font-weight-bold"
                  label="PAYMENT STATUS">
                <b-form-checkbox-group
                    id="checkbox-group-2"
                    :options="filters.paymentStatus"
                    v-model="filters.form.paymentStatus"
                    @change="onSelectFilter"
                    name="paymentStatus"
                    stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group
                  class="font-weight-bold"
                  label="STATUS">
                <b-form-checkbox-group
                    id="checkbox-group-3"
                    :options="filters.orderStatus"
                    v-model="filters.form.orderStatus"
                    @change="onSelectFilter"
                    name="orderStatus"
                    stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group
                  class="font-weight-bold"
                  label="VERSAND">
                <b-form-checkbox-group
                    id="checkbox-group-4"
                    :options="filters.transports"
                    v-model="filters.form.transports"
                    @change="onSelectFilter"
                    name="orderStatus"
                    stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group
                  class="font-weight-bold"
                  label="ÜBERWEISUNG">
                <b-form-checkbox
                    @change="onSelectFilter"
                    v-model="filters.isAdmin">Überweisung
                </b-form-checkbox>
              </b-form-group>
            </div>

          </b-card>
          <!--Filters-->
          <b-card>
            <small class="font-weight-bold text-success">You must select two dates</small>

            <b-form-group
                class="font-weight-bold"
                label="DATE FROM">
              <date-picker
                  format="YYYY-MM-DD"
                  display-format="YYYY-MM-DD"
                  @change="onSelectFilter"
                  locale="en" v-model="filters.form.orderDateFrom"></date-picker>
            </b-form-group>
            <b-form-group
                class="font-weight-bold"
                label="DATE TO">
              <date-picker
                  format="YYYY-MM-DD"
                  display-format="YYYY-MM-DD"
                  @change="onSelectFilter"
                  locale="en" v-model="filters.form.orderDateTo"></date-picker>
            </b-form-group>

            <a v-if="filters.form.orderDateFrom != null || filters.form.orderDateTo != null"
               @click.prevent="clearDatesForm"
               href="#" class="text-danger d-block">clear dates</a>
          </b-card>
          <!--Filter Date-->
        </div>
      </b-col>
      <!--END Filters-->


      <template v-if="orders.length > 0">
        <b-col cols="12" md="9">
          <div v-for="(item,index) in orders" :key="index">
            <order
                :numberItem="++index"
                :order="item">
              <template v-slot:checkbox>
                <b-form-checkbox
                    :id="'checkbox-'+item.id"
                    :name="'checkbox-'+item.id"
                    v-model="processGroup.form.orderIds"
                    :value="item.id"
                >
                  select
                </b-form-checkbox>
              </template>
            </order>
          </div>

          <template v-if="checkSearchIsNull">
            <infinite-loading :identifier="infiniteId" :distance="1"
                              @infinite="getOrders"></infinite-loading>
          </template>

        </b-col>
        <!--END Content-->
      </template>


    </b-row>


  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import {EventBus} from "../../Services/Eventbus/event-bus";

import Navbar from "../Partials/Navbar";
import Report from './components/reports.vue'
import Order from './components/order.vue'
// import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: "Index",
  components: {
    Navbar,
    Report,
    Order,
    // InfiniteLoading,
  },
  data() {
    return {
      role: null,
      page: 1,
      infiniteId: +new Date(),
      processGroup: {
        items: [
          {
            text: 'Steht aus',
            value: 'pending'
          },
          {
            text: 'Storniert',
            value: 'cancel'
          },
          {
            text: 'Bezahlt',
            value: 'paid'
          },
          {
            text: 'Nicht bezahlt',
            value: 'notpaid'
          },
          {
            text: 'Gesendet',
            value: 'posted'
          },
          {
            text: 'EC Karte bezahlt',
            value: 'pos'
          },
          {
            text: 'Bar bezahlt',
            value: 'cash'
          },
          {
            text: 'Abgeholt',
            value: 'pickedup'
          },
          {
            text: 'Zugestellt',
            value: 'reviewed'
          },
          {
            text: 'Abholbereit',
            value: 'abholbereit'
          },
          {
            text: 'Überweisung',
            value: 'admin'
          },
          {
            text: 'RAW / Inkasso',
            value: 'lawyer'
          },
          {
            text: 'Abgelehnt',
            value: 'rejectpurchaseinvoice'
          },
          {
            text: 'Bezahlt von Coin.de',
            value: 'paidpurchaseinvoice'
          },
          {
            text: 'Rechnung nochmal schicken',
            value: 'sendFactorOrderToUser'
          },
          {
            text: 'Coin.de / RAW',
            value: 'changePaymentDate'
          },

        ],
        form: {
          orderIds: [],
          type: null,
          orderPaymentDate: null,
        }
      },
      filters: {
        isAdmin: false,
        payment: [
          {
            text: 'eps',
            value: 'eps'
          },
          {
            text: 'vorkasse',
            value: 'vorkasse'
          },
          {
            text: 'nachname',
            value: 'nachname'
          },
          {
            text: 'card',
            value: 'card'
          },
          {
            text: 'giropay',
            value: 'giropay'
          },
          {
            text: 'Barzahlung bei Abholung',
            value: 'inperson'
          },
          {
            text: 'Card & NFC',
            value: 'posdevice'
          },
          {
            text: 'Kauf auf Rechnung',
            value: 'purhcaseoninvoice'
          },
        ],
        paymentStatus: [
          {
            text: 'Bezahlt',
            value: 'paid'
          },
          {
            text: 'Nicht bezahlt',
            value: 'unpaid'
          },
          {
            text: 'RAW / Inkasso',
            value: 'lawyer'
          },
          {
            text: 'Abgelehnt',
            value: 'rejectpurchaseinvoice'
          },
          {
            text: 'Bezahlt von Coin.de',
            value: 'paidpurchaseinvoice'
          },
        ],
        orderStatus: [
          {
            text: 'Steht aus',
            value: 'pending'
          },
          {
            text: 'Storniert',
            value: 'cancel'
          },
          {
            text: 'Gesendet',
            value: 'posted'
          },
          {
            text: 'Zugestellt',
            value: 'reviewed'
          },
          {
            text: 'Abgeholt',
            value: 'pickedup'
          },
          {
            text: 'Abholbereit',
            value: 'ready'
          },
        ],
        transports: [
          {
            text: 'Ihr Lieferservice in Wien',
            value: 6
          },
          {
            text: 'Österreich / Deutschland',
            value: 1
          },
          {
            text: 'Andere EU-Länder',
            value: 7
          },
          {
            text: 'Selbstabholung bei Lord of Hanf',
            value: 8
          }
        ],
        form: {
          paymentStatus: [],
          paymentType: [],
          orderStatus: [],
          transports: [],
          orderDateFrom: null,
          orderDateTo: null,
        }
      },
      orders: [],
      report: {},
      searchInput: null,
    }
  },
  watch: {
    searchInput(after, before) {
      this.onSelectFilter();
    }
  },
  methods: {
    clearDatesForm() {
      if (this.filters.form.orderDateFrom != null || this.filters.form.orderDateTo == null) {
        this.filters.form.orderDateFrom = null;
        this.filters.form.orderDateTo = null;
        this.page = 1;
        this.orders = [];
        this.infiniteId += 1;
        this.getOrders();
      }
    },
    onSelectPaymentDate() {
      if (confirm(this.$t('alertText'))) {
        this.SendProcessGroupOrderToServer();
      }
    },
    onSelectFilter() {
      this.page = 1;
      this.orders = [];
      this.infiniteId += 1;
      this.getOrders();
      this.$router.push({
        name: 'OrdersList',
        query: {
          paymentType: this.filters.form.paymentType,
          paymentStatus: this.filters.form.paymentStatus,
          orderStatus: this.filters.form.orderStatus,
          transports: this.filters.form.transports,
          orderDateFrom: this.filters.form.orderDateFrom,
          orderDateTo: this.filters.form.orderDateTo,
          isAdmin: this.filters.isAdmin,
        }
      })
    },
    getOrders($state) {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/index?page=' + this.page, {
        paymentStatus: this.filters.form.paymentStatus,
        paymentType: this.filters.form.paymentType,
        orderStatus: this.filters.form.orderStatus,
        transports: this.filters.form.transports,
        orderDateFrom: this.filters.form.orderDateFrom,
        orderDateTo: this.filters.form.orderDateTo,
        isAdmin: this.filters.isAdmin,
        search: this.searchInput,
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.report = response.data.data.reports;


              if (this.checkSearchIsNull) {
                if (response.data.data.orders.length > 0) {
                  this.page += 1;
                  this.orders.push(...response.data.data.orders);
                  $state.loaded();
                } else {
                  $state.complete();
                }
              } else {
                this.orders = response.data.data.orders;
              }


            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    processGroupOrder() {
      if (this.processGroup.form.type !== 'changePaymentDate' && confirm(this.$t('alertText'))) {
        this.SendProcessGroupOrderToServer();
      }
    },
    SendProcessGroupOrderToServer(){
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/process/group', this.processGroup.form)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.onSelectFilter();
              this.processGroup.form.type = null;
              this.processGroup.form.orderIds = [];
              Notification.success(response.data.message)
            } else {
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    }
  },
  computed: {
    checkSearchIsNull() {
      return this.searchInput === null || this.searchInput === "";
    }
  },
  created() {
    this.role = localStorage.getItem('role');

    if (this.role !== null && this.role === 'admin') {
      this.processGroup.items.push(
          {
            text: 'delete',
            value: 'delete'
          }
      )
    }

    if (!this.$route.query.paymentType &&
        !this.$route.query.paymentStatus &&
        !this.$route.query.orderStatus &&
        !this.$route.query.isAdmin
    ) {
      this.getOrders();
    }
  },
  mounted() {
    if (this.$route.query.paymentType) {
      this.filters.form.paymentType = (Array.isArray(this.$route.query.paymentType) ? this.$route.query.paymentType : [this.$route.query.paymentType]);
    }
    if (this.$route.query.paymentStatus) {
      this.filters.form.paymentStatus = (Array.isArray(this.$route.query.paymentStatus) ? this.$route.query.paymentStatus : [this.$route.query.paymentStatus]);
    }
    if (this.$route.query.orderStatus) {
      this.filters.form.orderStatus = (Array.isArray(this.$route.query.orderStatus) ? this.$route.query.orderStatus : [this.$route.query.orderStatus]);
    }
    if (this.$route.query.transports) {
      this.filters.form.transports = (Array.isArray(this.$route.query.transports) ? this.$route.query.transports : [this.$route.query.transports]);
    }

    if (this.$route.query.orderDateFrom) {
      this.filters.form.orderDateFrom = this.$route.query.orderDateFrom;
    }
    if (this.$route.query.orderDateTo) {
      this.filters.form.orderDateTo = this.$route.query.orderDateTo;
    }
    if (this.$route.query.isAdmin) {
      this.filters.isAdmin = (this.$route.query.isAdmin === "true");
    }

    if (this.$route.query.paymentType ||
        this.$route.query.paymentStatus ||
        this.$route.query.orderStatus ||
        this.$route.query.transports ||
        this.$route.query.orderDateFrom ||
        this.$route.query.orderDateTo ||
        this.$route.query.isAdmin
    ) {
      this.getOrders();
    }

  }
}
</script>

<style scoped>

</style>